(function () {
  var MARQUEE_SELECTOR = '.fab-marquee__track, .fab-hero__announce-track';

  function setMarqueeMotion(paused) {
    document.querySelectorAll(MARQUEE_SELECTOR).forEach(function (track) {
      if (paused) {
        track.style.animationPlayState = 'paused';
      } else {
        track.style.removeProperty('animation-play-state');
      }
    });
  }

  document.addEventListener('visibilitychange', function () {
    setMarqueeMotion(document.hidden);
  });

  if (!document.hidden) {
    requestAnimationFrame(function () {
      setMarqueeMotion(false);
    });
  }
})();
